var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPos1Ico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.313,
    height: 42.551,
    viewBox: "0 0 33.313 42.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9017",
    "data-name": "Path 9017",
    d: "M262.517,729.721l1.192.687,3.329-2.077-.887-.878Z",
    transform: "translate(-262.517 -727.453)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -27.87,
    y1: 90.399,
    x2: -27.764,
    y2: 90.399,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d07618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#d78319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#dc8a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de8d1a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9023",
    "data-name": "Path 9023",
    d: "M304,728.33l3.329,2.077,1.192-.687-3.635-2.268Z",
    transform: "translate(-304.001 -727.453)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -34.488,
    y1: 84.746,
    x2: -34.374,
    y2: 84.746,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9002",
    "data-name": "Path 9002",
    d: "M272.312,721.477H268.28l-2.046,3.452-3.329,2.077-.153,3.97-2.122,3.513L262.753,738l.153,3.97,3.329,2.078,2.046,3.45h4.031l3.574,2.017,3.573-2.017h4.031l2.046-3.45,3.331-2.078.152-3.97,2.123-3.512-2.123-3.513-.152-3.97-3.331-2.077-2.046-3.452h-4.031l-3.573-2.015Z",
    transform: "translate(-260.63 -719.462)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.906,
    y1: 15.32,
    x2: -4.887,
    y2: 15.32,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa917"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9027",
    "data-name": "Path 9027",
    d: "M265.575,736.418a12.436,12.436,0,1,0,12.435-12.436,12.435,12.435,0,0,0-12.435,12.436",
    transform: "translate(-265.575 -723.982)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -6.132,
    y1: 18.408,
    x2: -6.109,
    y2: 18.408,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fea910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#feac16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#fecf51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9028",
    "data-name": "Path 9028",
    d: "M267.926,737.419a11.085,11.085,0,1,0,11.085-11.085,11.085,11.085,0,0,0-11.085,11.085",
    transform: "translate(-267.926 -726.334)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -6.94,
    y1: 20.59,
    x2: -6.914,
    y2: 20.59,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f98409"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 64.319,
    height: 64.319,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M272.882,705.329a.411.411,0,0,0-.293.124l-.662.682a.409.409,0,0,0,.075.631l8.637,5.434.007-1.018v-5.852Z",
    transform: "translate(-271.811 -705.329)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 48.239,
    height: 45.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9037",
    "data-name": "Path 9037",
    d: "M287.2,705.329v5.852l.007,1.018,8.638-5.434a.409.409,0,0,0,.075-.631l-.662-.682a.411.411,0,0,0-.293-.124Z",
    transform: "translate(-287.195 -705.329)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 47.665,
    height: 45.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9039",
    "data-name": "Path 9039",
    d: "M284.253,715.125a1.683,1.683,0,1,0,1.683-1.682,1.683,1.683,0,0,0-1.683,1.682",
    transform: "translate(-284.253 -713.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -48.507,
    y1: 137.866,
    x2: -48.337,
    y2: 137.866,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdc6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fec041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb22a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 3.365,
    height: 1.947,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6809",
    "data-name": "Group 6809",
    transform: "translate(-620.118 -537.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9003",
    "data-name": "Path 9003",
    d: "M258.19,745.628l2.318,3.835,1.206-.323-2.123-3.513Z",
    transform: "translate(361.928 -182.04)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9004",
    "data-name": "Path 9004",
    d: "M262.226,752.067l.167,4.335,1.192-.687-.153-3.971Z",
    transform: "translate(360.21 -184.644)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9005",
    "data-name": "Path 9005",
    d: "M262.516,759.346l1.192-.687,3.329,2.078-.887.878Z",
    transform: "translate(360.086 -187.588)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9006",
    "data-name": "Path 9006",
    d: "M268.846,763.153l.887-.878,2.046,3.451-.7,1.2Z",
    transform: "translate(357.392 -189.128)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9009",
    "data-name": "Path 9009",
    d: "M313.588,745.628l-2.318,3.835-1.206-.323,2.122-3.513Z",
    transform: "translate(339.844 -182.04)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9010",
    "data-name": "Path 9010",
    d: "M311.157,752.067l-.167,4.335-1.192-.687.153-3.971Z",
    transform: "translate(339.957 -184.644)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9011",
    "data-name": "Path 9011",
    d: "M308.522,759.346l-1.192-.687L304,760.736l.887.878Z",
    transform: "translate(342.425 -187.588)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9012",
    "data-name": "Path 9012",
    d: "M303.371,763.153l-.887-.878-2.046,3.451.7,1.2Z",
    transform: "translate(343.941 -189.128)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9015",
    "data-name": "Path 9015",
    d: "M258.19,742.786l2.318-3.835,1.206.323-2.123,3.513Z",
    transform: "translate(361.928 -179.198)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9016",
    "data-name": "Path 9016",
    d: "M262.226,735.737l.167-4.335,1.192.687-.153,3.971Z",
    transform: "translate(360.21 -175.984)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(622.603 553.15)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 5.394,
    height: 5.054,
    transform: "translate(-1.408 1.03) rotate(-36.193)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9018",
    "data-name": "Path 9018",
    d: "M268.846,724.66l.887.877,2.046-3.451-.7-1.2Z",
    transform: "translate(357.392 -171.509)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9021",
    "data-name": "Path 9021",
    d: "M313.588,742.786l-2.318-3.835-1.206.323,2.122,3.513Z",
    transform: "translate(339.844 -179.198)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9022",
    "data-name": "Path 9022",
    d: "M311.157,735.737l-.167-4.335-1.192.687.153,3.971Z",
    transform: "translate(339.957 -175.984)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(646.426 553.15)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 5.054,
    height: 5.394,
    transform: "matrix(0.591, -0.807, 0.807, 0.591, -1.408, 1.924)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9024",
    "data-name": "Path 9024",
    d: "M303.371,724.66l-.887.877-2.046-3.451.7-1.2Z",
    transform: "translate(343.941 -171.509)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773",
    transform: "translate(621.519 537.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607",
    transform: "translate(0 11.117)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 30.511,
    height: 30.054,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9007",
    "data-name": "Path 9007",
    d: "M273.434,768.284h4.031l-.328,1.2h-4.4Z",
    transform: "translate(-265.784 -729.13)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9008",
    "data-name": "Path 9008",
    d: "M284.3,771.681V770.3l-3.574-2.017-.328,1.2Z",
    transform: "translate(-269.047 -729.13)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9013",
    "data-name": "Path 9013",
    d: "M297.45,768.284h-4.031l.328,1.2h4.4Z",
    transform: "translate(-274.589 -729.13)",
    fill: "#ee9615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9014",
    "data-name": "Path 9014",
    d: "M287.195,771.681V770.3l3.574-2.017.328,1.2Z",
    transform: "translate(-271.939 -729.13)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9019",
    "data-name": "Path 9019",
    d: "M273.434,722.087h4.031l-.328-1.2h-4.4Z",
    transform: "translate(-265.784 -708.953)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9020",
    "data-name": "Path 9020",
    d: "M284.3,717.059v1.379l-3.574,2.017-.328-1.2Z",
    transform: "translate(-269.047 -707.322)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9025",
    "data-name": "Path 9025",
    d: "M297.45,722.087h-4.031l.328-1.2h4.4Z",
    transform: "translate(-274.589 -708.953)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9026",
    "data-name": "Path 9026",
    d: "M287.195,717.059v1.379l3.574,2.017.328-1.2Z",
    transform: "translate(-271.939 -707.322)",
    fill: "#ffb03a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(2.84 13.713)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 24.871,
    height: 24.871,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(4.19 15.064)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 22.171,
    height: 22.17,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625",
    transform: "translate(4.19 15.064)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(-21.12 -20.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 64.319,
    height: 64.319,
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9030",
    "data-name": "Path 9030",
    d: "M290.8,701.8v1.359h-28V701.8l1.7-1.7h24.6Z",
    transform: "translate(-261.557 -700.103)",
    fill: "#fff2b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9031",
    "data-name": "Path 9031",
    d: "M290.8,705.432v1.308l-1.7,1.768h-24.6l-1.7-1.768v-1.308Z",
    transform: "translate(-261.557 -702.372)",
    fill: "#dfa53f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M289.01,701.033H265.6l-1.618,1.4v2.2l1.618,1.46h23.41l1.618-1.46v-2.2Z",
    transform: "translate(-262.057 -700.499)",
    fill: "#ffc835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M280.638,712.2,272,706.766a.409.409,0,0,1-.076-.631l.663-.682a.411.411,0,0,1,.293-.123h7.764v5.852Z",
    transform: "translate(-265.39 -702.328)",
    fill: "#ef5717"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    transform: "translate(6.421 3.001)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(-18.183 -20.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 48.239,
    height: 45.942,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUAAABRCAYAAACjZOpMAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAVaADAAQAAAABAAAAUQAAAADb5qtJAAAE0ElEQVR4Ae3azW4jRRAH8KruGdvjj0CczZcTlCAhhEAghLhw4wE4cecdeAKQeCBOiAscuHFBC9ocWDgQVotsswmxk9iTsWe6ixpjC4Q4dIttzUSqkaKJrEpp8pu/u3osIxGBHM9XQD3fdtKtFBDUADkQVEENIBCgpSRVUAMIBGgpSRXUAAIBWkpSBTWAQICWklRBDSAQoKUkVVADCARoKUkV1AACAVpKUgU1gECAlpJUQQ0gEKClJFVQAwgEaClJFdQAAgFaSlIFNYBAgJaSVEENIBCgpSRVUAMIBGgpSQ2AGgXo+b9aDvEQ/6vBgEb35ou0WJcv/a4xS1BsfVDgo1l7hftWN6Xsi6gE3fxA3YFrgboGVeMPdZQ8o+g2Uzpug7I3LKmAighta2aL9AVlTr/NDQPbwdUYYLueXwOvHHUDOno7itOWSRoFtrWGhBAaqBnWguHILkFR1rTqDv6A7Gqg81e/WZa4VMfUVo6afdpRD7/aiRoLSpYRvRgDPCCgPmjo8RSNOYvGItzxd76vlYGJLWDaaKs5pzh7+Tgr2u+ktvVxSnVKbeWonFTFKW2YCHqo7b4lOEGEY0Dc4yB2OY3AsKlCuCTAsUEaxRYurFHTXsumv0fRskwtLwe1ga3N9FctZjTl2x1jBOrwAN1hz11+6yeAYHhKTS3QWBH0IYKnpGg0I7rsRfb21/fiDPoHxYAjXt6Eqo/K96n9T25gkaDFGSwtwFxpmJKGCb/dZ5zYggdVk6V2GPaEL/Y1fu1NY+ENJHhFWRzQ3PD4guZ32y21Xp+rNuV7XvFx9dkWnUJunr2uF9S1N0Wmx7yeqtXd5oRyUnO+xF3OYIfPO3xucVrbPMgSvgkatCr0khZHJ0XOt4Jfqj6tlSd1Pb3t8DTOk0jNO7x2agVPkPAxWXzEKT1jpp8YccjntETl9O7zQvsS/35kc+oXitqdxERf73WwDmmtPKnlG2UFi4flFmnBQ8tGCRYFmgUavOXF9EoBXiiiY8Y8Jgt7nIQGLwcNhm7zcpAwbjzvaPXgXQ72l2XHao/Kk7r59zeJPfyhWF4rNe8qnDQBRzy4fmG4H62CM94FnPFa+5gxnzDqJWPOeW3NY97D5Df8W02OWiR1Y7GCnfAqypOcX7M81fM+FIuZ1nc6pxlovCZDFzzItjnB/IzAQ03RlGsznlb2vNeoBWzl+9QN6L/P5drIOwNMH7bV+W+tSG1Ba5naDsawxZjdJT8YRBYzq2nSRJzafUgPPjc535hyWFV61BZ1o7IePPjz+w3dH5rY7kJzZqjR1BQteeFtN1VWPl3xslHuEux6Gdn8eSXn2qOuVCaIw/4BdD5aqO+f9tR2x2g6B4yOCG5m+u8PWWry8eD9QF3n7R/bJV54/zrKh4dyr1uHhG6u6V6hbi667ufabKnqDuVzfYLqo+VYK6iOUD5lguqj5VgrqI5QPmWC6qPlWCuojlA+ZYLqo+VYK6iOUD5lguqj5VgrqI5QPmWC6qPlWCuojlA+ZYLqo+VYK6iOUD5lguqj5VgrqI5QPmWC6qPlWCuojlA+ZYLqo+VYK6iOUD5lguqj5VgrqI5QPmWC6qPlWCuojlA+ZYLqo+VYK6iOUD5lguqj5VgrqI5QPmWC6qPlWCuojlA+ZX8CYUHCAUiABKsAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M276.351,705.33l6.227,4.1v-1.8l-3.583-2.3Z",
    transform: "translate(-267.323 -702.328)",
    fill: "#fed2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9036",
    "data-name": "Path 9036",
    d: "M287.2,712.2l8.637-5.434a.409.409,0,0,0,.076-.631l-.663-.682a.411.411,0,0,0-.293-.123H287.2v5.852Z",
    transform: "translate(-271.939 -702.328)",
    fill: "#eb3f1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(15.256 3.001)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636",
    transform: "translate(-20.7 -20.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 47.665,
    height: 45.942,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAYAAABMpoFyAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAVKADAAQAAAABAAAAUQAAAABcQGAKAAAEiElEQVR4Ae3bS09bRxQH8HNmru1rG4IDCcINSkBpI2VXRd1010133fdr9BN00e/UfbrqpouusqhaCRCvEGIexvZ9zZyecXBVVbObqe4gnStdDMfM4fLjP3PHCJCIQI54AipeK+nkBAQ0cg4EVEAjC0RuJwkV0MgCkdtJQgU0skDkdpJQAY0sELmdJFRAIwtEbicJFdDIApHbSUIFNLJA5HaSUAGNLBC5nSRUQCMLRG4nCRXQyAKR20lCBTSyQOR2klABjSwQuZ0kVEAjC0RuJwkV0MgCkdtJQiODZpH7/S/tTnGMvsaf0Vlyf9yKqf7B7b8QHeby7H5jlrDVW+0g/zlTgk0P9ArxdHPHBVIdfN3Rgxur+2s2mzZaoV3CgsnArufWTAvV7P7WNPy5NhXUpEDvU4nvhj29/azp2AzyckB9WEBOGrs6I20rtGiosgCLfBPnZoaL8e9NnQpqMmvoPaY6+zLrbD0y+fwDDVHhSBl8jB3a4BneRwOa3685oVOuT2Z3cNnTYDnJ9s23H1dLgEt3a0cSCb3H1JevdJclBuWQRhnCNk/mMSnYQYInro68J7EEd0B4gZaOyeJhv4T31RpOOaUVT3sObrtH6wl1mPl3jT7+o9ethrhuanrCgM8MwQsGfMG3nh1eOUeIoJlqoQgurKIZAXZQk1I9ftZ6NwGtyLYOyt81/nme6/4GDayhLV4n9ziFL5nJnbv8/IhRNf/3z5w/njLsHQJecViveeWcFR1VlX20mz/etgL43y/a6sbepfOX74c4uKKsrOxQG3hqDOxx3r7gC90nC08Z0y0DC07ke15DD4jwL410yGvq+VoOt7qicu/X2kx+epTEnrT1hG5MDc5qpRmpZxRt8E/YrZdbnMQBn7W1cMMfnwLSAU/6o4zXzoanfd7FaxjS/Pm4rIt3WTLbptZBGQvc/lLxHZwTqXlaKz4bnvZXvJZOCeGM181DnvJHnNzzRtNHRXpa1VCM35q6gHQw3feSBCjfycloaBiyYMRrfjxhUMsJveTEnvBm6YTv6he5ghu6UbPbbax5mrsNPaWyoXeY7mgd9GZd0/NObWYFLHQPJpzPI2txwnfwEixccio/WLITBXpaWCj2XxfN52/mNv95TvA4vX9UbX0fyjcmdfxV1umUvP/M7ahrYWQNdBiyrDVM14Gn/TXOb7dVsqn8lM1Pb1MAZTtYvkLix3xOtqcsqFEXmhmqUjdQ7e8WzcCl8oc0U5kUqLuY+1dKy1+G9BakeCuE1QAt/+LD8NPu1U9ya6W7bt/RekJXF+VQeXOOvJ9cldzjg4FcXXQyoKsLeuiPrb5Seuh4vusXUJ9KQE1AA/B8QwXUpxJQE9AAPN9QAfWpBNQENADPN1RAfSoBNQENwPMNFVCfSkBNQAPwfEMF1KcSUBPQADzfUAH1qQTUBDQAzzdUQH0qATUBDcDzDRVQn0pATUAD8HxDBdSnElAT0AA831AB9akE1AQ0AM83VEB9KgE1AQ3A8w0VUJ9KQE1AA/B8QwXUpxJQE9AAPN9QAfWpBNQENADPN/RvEv+soS7dcuoAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9038",
    "data-name": "Path 9038",
    d: "M293.423,705.33l-6.227,4.1v-1.8l3.583-2.3Z",
    transform: "translate(-271.939 -702.328)",
    fill: "#fed2bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    transform: "translate(13.567 7.661)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 3.365,
    height: 3.365,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650",
    transform: "translate(13.567 7.66)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9040",
    "data-name": "Path 9040",
    d: "M287.619,715.124a1.605,1.605,0,0,1-.021.264,1.682,1.682,0,0,0-3.322,0,1.605,1.605,0,0,1-.021-.264,1.682,1.682,0,1,1,3.365,0",
    transform: "translate(-284.254 -713.441)",
    fill: "#fce689"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9041",
    "data-name": "Path 9041",
    d: "M283.307,733.583h3.064a.251.251,0,0,1,.252.252v14.187a.251.251,0,0,1-.252.252h-2.98a.251.251,0,0,1-.252-.252v-11.1a.122.122,0,0,0-.042-.084.069.069,0,0,0-.084-.021l-2.056.483-.084.021c-.126,0-.189-.076-.189-.231l-.042-2.2a.3.3,0,0,1,.189-.294l2.162-.944a.9.9,0,0,1,.315-.063",
    transform: "translate(-269.149 -714.356)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos1Ico);
export default __webpack_public_path__ + "static/media/pos1-ico.cb689d05f301bf80aa47bac52d5ba2c4.svg";
export { ForwardRef as ReactComponent };